import { render } from "./BarChartContainer.vue?vue&type=template&id=757911e4"
import script from "./BarChartContainer.vue?vue&type=script&lang=js"
export * from "./BarChartContainer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__